import * as React from 'react';
import Col from 'reactstrap/lib/Col';
import { Row, Input, Button } from 'reactstrap';
import { CaseInfoForm } from '../components/TransferForm';
import { TransferInfoForm } from '../components/TransferInfoForm';
import { TransferComponent } from "../Transfer";
import { Form } from '../../../../share/components/Form/Form';
import { BeatLoader } from 'react-spinners';

const Header = (propsp) => (
  <Row>
    <Col md={12}>
      <h5 className="header">{propsp.children}</h5>
    </Col>
  </Row>
)
const Title = ({ that }) => (
  <Row>
    <Col md={12}>
      <h3>
        {that.isInfoCase() ? `${that.getCaseId(window.location.pathname)}` : "Cross-border notification"}
      </h3>

    </Col>
  </Row>
)

const Circumstances = ({ that, loading, readOnly, submitted }) => (
  <CaseInfoForm
    disabled={loading || readOnly} caseInfo={that.props.caseData || {}}
    form={that.form} submitted={submitted} agencies={that.state.agencies} targetAgency={that.state.targetAgency}
    transferCaseInformation={that.state.transferCaseInformation}
  />
)

const Children = ({ that, loading, readOnly }) => {
  return (
    <TransferInfoForm
      type="child" form={that.form}
      disabled={loading || readOnly} setValue={that.setValue} personsInfo={that.props.caseData.children}
    />
  )
}

const Buttons = ({ that }: { that: TransferComponent }) => (
  <Row>
    <Col md="12" className="text-center container-padding">
      {renderSubmitView(that)}
    </Col>
  </Row>
)

const AdvancedLayout = (props: { that, loading, readOnly, caseInfo, isEditCase, submitted }) => {
  return (
    <>
      <Row>
        <Col md={12} className="container-padding">
          <Title {...props} />
        </Col>
      </Row>
      <Row>
        <Col md={6} className="container-padding">
          <Header>Missing info</Header>
          <Circumstances  {...props} />
        </Col>
        <Col md={6} className="container-padding">
          <Header>{props.that.props.caseData.children.lenght > 1 ? "Childre's" : "Child's"} info </Header>
          <Children {...props} />
        </Col>
      </Row>
      <Row>
        <Col md={12} className="container-padding" >
          <Input className="transfer-text" type="textarea"
            name="text" id="exampleText" placeholder="Cross border information"
            {...props.that.form('transferCaseInformation')} />
        </Col>
      </Row>
      <Buttons {...props} />
    </>
  )
}


export const TransferCaseContainer = ((props) => {
  const that: TransferComponent = props.that;
  const { loading } = that.props;
  const { component } = that.state
  return (
    <div className="case caseTransfer">
      <div className={"content white-background"}>
        <Form key={component} onSubmit={that.handleSubmit} onValidSubmit={that.handleValidSubmit}>
          {
            <AdvancedLayout that={that} {...that.state} readOnly={false} />
          }
        </Form>
        <div className="help-loader">
          <BeatLoader loading={loading} />
        </div>
      </div>

    </div>
  )
})

const renderSubmitView = (that) => {
  return that.state.readOnly ?
    <>
    </>
    :
    <Button block={true} type="submit" id="submitBTN" className="btn btn-outline float-right btn-green-fill">
      Submit
        </Button>
}


// WEBPACK FOOTER //
// ./src/modules/Case/TransferCase/layouts/Transfer.tsx